// extracted by css-extract-rspack-plugin
export default {"Box":"AddSubIssueButtonGroup-module__Box__azdei"};